import { render, staticRenderFns } from "./TNOSWaitingTable.vue?vue&type=template&id=456b273a"
import script from "./TNOSWaitingTable.vue?vue&type=script&lang=js"
export * from "./TNOSWaitingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports